import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '@/services/apiClient'
import type { Approval, ApprovalListResponse } from '@/types/toolFramework'

export function useApprovals(filters?: { status?: string; personaId?: string }) {
  return useQuery({
    queryKey: ['approvals', { status: filters?.status, personaId: filters?.personaId }],
    queryFn: () => {
      const params = new URLSearchParams()
      if (filters?.status) params.set('status', filters.status)
      if (filters?.personaId) params.set('persona_id', filters.personaId)
      const qs = params.toString()
      return apiClient
        .get<ApprovalListResponse>(`/api/approvals${qs ? `?${qs}` : ''}`)
        .then((r) => r.approvals as Approval[])
    },
  })
}

export function useApproveApproval() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      apiClient.post(`/api/approvals/${id}/approve`, {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['approvals'] })
    },
  })
}

export function useRejectApproval() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) =>
      apiClient.post(`/api/approvals/${id}/reject`, {}),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['approvals'] })
    },
  })
}
